/* eslint-disable max-len */
document.addEventListener( 'DOMContentLoaded', function () {
  function addMenuHoveredClass() {
    if ( window.innerWidth <= 1199 ) return;
    document.querySelector( 'body' ).classList.add( 'menu-hover' );
    document.querySelector( 'header .max-mega-menu' )?.classList.add( 'mega-menu-hover' );
  }

  function removeMenuHoveredClass() {
    if ( window.innerWidth <= 1199 ) return;
    document.querySelector( 'body' ).classList.remove( 'menu-hover' );
    document.querySelector( 'header .max-mega-menu' )?.classList.remove( 'mega-menu-hover' );
  }

  function appendTopMenuItemsToMain() {
    const sourceItems = document.querySelectorAll( '.e-div--header-top-menu .wp-block-navigation__container > li' );
    const targetContainer = document.querySelector( '.e-div--header-main-menu #mega-menu-primary_menu' );
    if ( targetContainer ) {
      sourceItems.forEach( item => {
        targetContainer.appendChild( item.cloneNode( true ) );
      } );
    }
  }

  function initMobileGroupHeadings() {
    // Prevent accidental taps on non-clickable section group headers in mobile
    const groupHeadings = document.querySelectorAll(
      '#mega-menu-primary_menu .mega-menu-column .mega-menu-item-has-children > a'
    );
    groupHeadings.forEach( heading => {
      heading.addEventListener( 'click', e => e.preventDefault() );
    } );
  }

  function initializeMenuBehavior() {
    const menus = document.querySelectorAll( '.dpn-tpe-2' );

    menus.forEach( menu => {
      const subMenus = menu.querySelectorAll( '.mega-menu-column > .mega-sub-menu > .mega-menu-item' );
      subMenus.forEach( subMenu => subMenu.classList.add( 'active' ) );
    } );
  }

  function hidePdfResourceTagInNav() {
    const taxonomyLabels = document.querySelectorAll( '#mega-menu-primary_menu .e-mtf--taxonomy' );
    taxonomyLabels.forEach( label => {
      const terms = label.textContent.split( ',' ).map( term => term.trim() ).filter( Boolean );
      const filteredTerms = terms.filter( term => term.toLowerCase() !== 'pdf resource' );
      label.textContent = filteredTerms.join( ', ' );
    } );
  }

  const menuItems = document.querySelectorAll( 'header .max-mega-menu > li.mega-menu-item:not(.rst-a-dmo-btn, .menu-search-icon)' );
  menuItems.forEach( item => {
    item.addEventListener( 'mouseenter', addMenuHoveredClass );
    item.addEventListener( 'mouseleave', removeMenuHoveredClass );
  } );

  appendTopMenuItemsToMain();
  initializeMenuBehavior();
  initMobileGroupHeadings();
  hidePdfResourceTagInNav();
} );
